const { REACT_APP_APIURL: API_URL, REACT_APP_S3BUCKET_FILEURL: FILE_URL } =
  process.env;

const urlConstant = {
  Login: {
    UserLogin: `${API_URL}Authentication/Login`,
    GetUserDetail: `${API_URL}Authentication/GetUserDetail`,
    ChangePassword: `${API_URL}Authentication/ResetPassword`,
    UpdateProfile: `${API_URL}Authentication/UpdateProfile`,
    GetUserList: `${API_URL}Authentication/GetUserList`,
    UpdateUser: `${API_URL}Authentication/UpdateUser`,
    DeleteUser: `${API_URL}Authentication/DeleteUser`,
    AddUser: `${API_URL}Authentication/Register`,
    ResetUserPassword: `${API_URL}Authentication/ResetUserPassword`,
    UserStatusUpdate: `${API_URL}Authentication/UserStatusUpdate`,
    ForgotPassword: `${API_URL}Authentication/ForgotPassword`,
    ResetUserPasswordByToken: `${API_URL}Authentication/ResetPasswordUsingTokenFromEmail`,
    UserLogout: `${API_URL}Authentication/Logout`,
    RefreshToken: `${API_URL}Authentication/GetRefreshToken`,
  },
  Submission: {
    GetPendingSubmissionList: `${API_URL}Submission/GetPendingSubmissionList`,
    GetSubmissionById: `${API_URL}Submission/GetSubmissionsById`,
    UpdateIntakeFormSubmit: `${API_URL}Submission/UpdateSubmission`,
    ApprovedSubmission: `${API_URL}Submission/ApproveSubmission`,
    DeleteSubmission: `${API_URL}Submission/DeleteSubmissionById`,
    GetAllFilterDropDowns: `${API_URL}Submission/GetAllFilterDropDowns`,
    VerifyMarketerCode: `${API_URL}Submission/VerifyMarketerCode`,
    SubmissionAttachment: `${API_URL}Submission/SubmissionAttachment`,
    GetFileUrl: `${API_URL}Submission/GetFileUrl`,
  },
  City: {
    GetAllCities: `${API_URL}City/GetAllCities`,
    GetAllCitiesWithoutStatusCheck: `${API_URL}City/GetAllCitiesWithoutStatusCheck`,
    GetAllCityAssociateWithLiaison: `${API_URL}City/GetAllCityAssociateWithLiaison`,
  },
  IntakeForm: {
    IntakeFormSubmit: `${API_URL}Submission/CreateSubmissionForm`,
  },
  Dashboard: {
    GetDailySubmissionsCounts: `${API_URL}Submission/GetDailySubmissionsCounts`,
    GetPendingSubmissionListByDaysBack: `${API_URL}Submission/GetPendingSubmissionListByDaysBack`,
    GetDailySubmissionRecords: `${API_URL}Submission/GetDailySubmissionRecords`,
  },
  WellSky: {
    GetApprovedSubmissionList: `${API_URL}Submission/GetApprovedSubmissionList`,
  },
  State: {
    GetAllStates: `${API_URL}State/GetAllStates`,
    GetAllStateAndCity: `${API_URL}State/GetStateAndCityGlobalSearch`,
    UpdateStateAndCity: `${API_URL}State/UpdateStateAndCity`,
    CreateStateAndCity: `${API_URL}State/CreateStateAndCity`,
    DeleteStateAndCity: `${API_URL}State/DeleteStateAndCityByStateId`,
    GetStateAndCityByStateId: `${API_URL}State/GetStateAndCityByStateId`,
  },
  Liaison: {
    GetAllActiveLiaisons: `${API_URL}Liaison/GetAllLiaisonGlobalSearch`,
    GetLiaison: `${API_URL}Liaison/GetLiaisonById`,
    CreateLiaison: `${API_URL}Liaison/CreateLiaison`,
    UpdateLiaison: `${API_URL}Liaison/UpdateLiaison`,
    DeleteLiaison: `${API_URL}Liaison/DeleteLiaison`,
  },
  Marketer: {
    GetAllMarketers: `${API_URL}Marketer/GetPaginatedMarketersWithGlobalSearch`,
    CreateMarketers: `${API_URL}Marketer/CreateMarketer`,
    UpdateMarketers: `${API_URL}Marketer/UpdateMarketer`,
    DeleteMarketers: `${API_URL}Marketer/DeleteMarketer`,
  },
  ProfileImage: {
    ProfileImageUrl: `${FILE_URL}`,
    UpdateProfileImage: `${API_URL}Authentication/UpdateProfileImage`,
    DeleteProfileImage: `${API_URL}Authentication/DeleteProfileImage`,
  },
  SignImage: {
    ErnieSignImageUrl: `${FILE_URL}Signature_Images/Ernie_Sign.png`,
  },
};

export default urlConstant;
